import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Type,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AccessibilityThemeService } from '../../services/accessibility.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { vermittlerLogoDataUri } from '../../misc/helpers';

@Component({
  selector: 'ui-header',
  imports: [CommonModule, NgComponentOutlet, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  readonly title = input('');
  readonly vermitlerLogo = input.required<string | undefined>();
  readonly showDefaultLogo = input(false);
  readonly brandExtra = input<Type<unknown> | undefined>();
  readonly brandSecondary = input<Type<unknown> | undefined>();
  readonly showPoweredByCpit = input(true);
  readonly stepInfo = input<string | undefined>();
  readonly logoClick = output<void>();

  private readonly themeService = inject(AccessibilityThemeService);

  isAccessibleMode = signal(false);

  logoSrc = computed(() => vermittlerLogoDataUri(this.vermitlerLogo()));

  /** A logo arrived but matched no format sniff — fall back to the default
   * logo instead of showing the loading spinner forever. */
  protected readonly unrecognizedLogo = computed(() => !!this.vermitlerLogo() && !this.logoSrc());

  protected readonly accessibleModeLabelClass = computed(() =>
    this.brandExtra() ? 'hidden xl:flex' : 'hidden md:flex'
  );

  protected readonly firstRowStepInfo = computed(() =>
    this.brandSecondary() ? undefined : this.stepInfo()
  );

  ngOnInit(): void {
    this.isAccessibleMode.set(this.themeService.isEnabled());
  }

  toggleAccessibleMode() {
    const newValue = !this.isAccessibleMode();
    this.isAccessibleMode.set(newValue);
    this.themeService.toggle();
  }
}
